import { Component, createRef } from 'react';

import Field from 'Lib/components/form/Field';

/**
 * Form field component for text input
 * @deprecated Use the Trellis Input.Text component instead: https://main--6710219e5989b079dbcc9421.chromatic.com/?path=/docs/components-input-text--docs
 */
class TextField extends Component {
	ref = createRef();

	componentDidMount() {
		if (this.props.autoFocus) {
			this.ref.current.focus();
		}
	}

	handleChange = (e, form, field) => {
		const { onChange, trim } = this.props;

		if (onChange) {
			onChange(e, form, field);
		}

		if (trim) {
			form.setFieldValue(field.name, e.target.value.trim());
		} else {
			form.handleChange(e);
		}

		form.setFieldTouched(field.name, true);
	};

	handleBlur = (e, form, field) => {
		const { onBlur } = this.props;

		if (onBlur) {
			onBlur(e, form, field);
		}

		form.handleBlur(e);
		form.setFieldTouched(field.name, true);
	};

	renderInput = props => {
		const { form, field, initialValues } = props;
		const { id, className, maxLength, minLength, required, readOnly, placeholder, preventPaste } = this.props;

		if (field.value == null) {
			field.value = '';
		}

		if (initialValues) {
			field.value = initialValues;
		}

		const attrs = {
			...field,
			id,
			className,
			maxLength,
			minLength,
			required,
			placeholder
		};

		if (attrs.className) {
			attrs.className = 'form-control ' + attrs.className;
		} else {
			attrs.className = 'form-control';
		}

		if (readOnly) {
			attrs.className = attrs.className + ' read-only';
		}

		return (
			<input
				{...attrs}
				type="text"
				autoComplete="off"
				ref={this.ref}
				data-testid={this.props['data-testid']}
				readOnly={readOnly ? true : ''}
				onChange={e => {
					this.handleChange(e, form, field);
				}}
				onBlur={e => {
					this.handleBlur(e, form, field);
				}}
				onPaste={e => {
					if (preventPaste) e.preventDefault();
				}}
			/>
		);
	};

	render() {
		return <Field {...this.props} render={props => this.renderInput(props)} />;
	}
}

export default TextField;
